/**
 * Birthstone Cart Validator
 * 
 * Blocks removal of chain when birthstones are in cart.
 * Shows tooltip explaining why removal is disabled.
 */

(function() {
  const CHAIN_HANDLE = 'curb-chain-ketting';
const TOOLTIP_MESSAGE = 'Birthstones kunnen alleen in combinatie met deze ketting worden besteld. Verwijder eerst de birthstones.';  
  let isProcessing = false;
  
  // Inject CSS for tooltip and disabled state
  function injectStyles() {
    if (document.getElementById('birthstone-validator-styles')) return;
    
    const styles = document.createElement('style');
    styles.id = 'birthstone-validator-styles';
    styles.textContent = `
      .birthstone-chain-locked {
        position: relative;
      }
      
      .birthstone-chain-locked .birthstone-remove-disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed;
        text-decoration: none !important;
      }
      
      .birthstone-chain-locked .birthstone-quantity-disabled {
        opacity: 0.4;
        pointer-events: none;
      }
      
      .birthstone-tooltip {
        display: block;
        background-color: #333;
        color: #fff;
        font-size: 12px;
        padding: 8px 12px;
        border-radius: 4px;
        margin-top: 8px;
        line-height: 1.4;
      }
      
      .birthstone-tooltip::before {
        content: "ℹ️ ";
      }
    `;
    document.head.appendChild(styles);
  }
  
  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }
  
  function findCartItemElement(handle) {
    // Find the cart item element for a specific product handle
    // Try multiple selectors for different themes
    
    // Method 1: Look for product links containing the handle
    const productLinks = document.querySelectorAll(`a[href*="/products/${handle}"]`);
    for (const link of productLinks) {
      const cartItem = link.closest('.mini-cart__item, .cart-item, [data-cart-item], .line-item, tr');
      if (cartItem) return cartItem;
    }
    
    // Method 2: Look for data attributes
    const itemByData = document.querySelector(`[data-product-handle="${handle}"], [data-handle="${handle}"]`);
    if (itemByData) {
      return itemByData.closest('.mini-cart__item, .cart-item, [data-cart-item], .line-item, tr') || itemByData;
    }
    
    // Method 3: Search by product title in cart
    const cartItems = document.querySelectorAll('.mini-cart__item, .cart-item, [data-cart-item], .line-item');
    for (const item of cartItems) {
      const titleEl = item.querySelector('.mini-cart__item-title, .cart-item__title, .line-item__title, a');
      if (titleEl && titleEl.href && titleEl.href.includes(handle)) {
        return item;
      }
    }
    
    return null;
  }
  
  function lockChainItem(chainElement) {
    if (!chainElement || chainElement.classList.contains('birthstone-chain-locked')) return;
    
    chainElement.classList.add('birthstone-chain-locked');
    
    // Find and disable remove button/link
    const removeButtons = chainElement.querySelectorAll('[data-action="remove"], .mini-cart__item-remove, .cart-item__remove, a[href*="/cart/change"], button[name="minus"], .quantity__button--minus, [data-quantity-minus]');
    removeButtons.forEach(btn => {
      btn.classList.add('birthstone-remove-disabled');
      btn.setAttribute('data-original-title', btn.getAttribute('title') || '');
      btn.setAttribute('title', TOOLTIP_MESSAGE);
    });
    
    // Also find "Verwijderen" text links
    const allLinks = chainElement.querySelectorAll('a, button');
    allLinks.forEach(link => {
      const text = link.textContent.toLowerCase().trim();
      if (text === 'verwijderen' || text === 'remove' || text === 'delete') {
        link.classList.add('birthstone-remove-disabled');
        link.setAttribute('data-original-title', link.getAttribute('title') || '');
        link.setAttribute('title', TOOLTIP_MESSAGE);
      }
    });
    
    // Disable minus button to prevent reducing to 0
    const minusButtons = chainElement.querySelectorAll('[data-action="decrease-quantity"], .quantity__button--minus, button[name="minus"], .quantity-selector__button:first-child');
    minusButtons.forEach(btn => {
      btn.classList.add('birthstone-quantity-disabled');
    });
    
    // Add tooltip message
    if (!chainElement.querySelector('.birthstone-tooltip')) {
      const tooltip = document.createElement('div');
      tooltip.className = 'birthstone-tooltip';
      tooltip.textContent = TOOLTIP_MESSAGE;
      
      // Find best place to insert tooltip
      const itemInfo = chainElement.querySelector('.mini-cart__item-info, .cart-item__info, .line-item__info');
      if (itemInfo) {
        itemInfo.appendChild(tooltip);
      } else {
        chainElement.appendChild(tooltip);
      }
    }
  }
  
  function unlockChainItem(chainElement) {
    if (!chainElement || !chainElement.classList.contains('birthstone-chain-locked')) return;
    
    chainElement.classList.remove('birthstone-chain-locked');
    
    // Re-enable all disabled buttons
    const disabledButtons = chainElement.querySelectorAll('.birthstone-remove-disabled, .birthstone-quantity-disabled');
    disabledButtons.forEach(btn => {
      btn.classList.remove('birthstone-remove-disabled', 'birthstone-quantity-disabled');
      const originalTitle = btn.getAttribute('data-original-title');
      if (originalTitle) {
        btn.setAttribute('title', originalTitle);
      } else {
        btn.removeAttribute('title');
      }
    });
    
    // Remove tooltip
    const tooltip = chainElement.querySelector('.birthstone-tooltip');
    if (tooltip) tooltip.remove();
  }
  
  async function validateCart() {
    if (isProcessing) return;
    
    try {
      isProcessing = true;
      const cart = await getCart();
      
      // Find chain and birthstones in cart
      let chainInCart = false;
      let birthstonesInCart = false;
      
      cart.items.forEach(item => {
        if (item.handle === CHAIN_HANDLE) {
          chainInCart = true;
        }
        
        // Check for birthstone products (could be "birthstone-hanger" or "birthstone-ketting")
        if (item.handle && (item.handle.includes('birthstone-hanger') || item.handle.includes('birthstone-ketting')) && item.handle !== CHAIN_HANDLE) {
          birthstonesInCart = true;
        }
      });
      
      // Find chain element in DOM
      const chainElement = findCartItemElement(CHAIN_HANDLE);
      
      if (chainInCart && birthstonesInCart && chainElement) {
        // Lock the chain - prevent removal
        lockChainItem(chainElement);
      } else if (chainElement) {
        // Unlock the chain - allow removal
        unlockChainItem(chainElement);
      }
      
    } catch (error) {
      console.error('Cart validation error:', error);
    } finally {
      isProcessing = false;
    }
  }
  
  // Initialize
  injectStyles();
  
  // Run validation when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(validateCart, 100));
  } else {
    setTimeout(validateCart, 100);
  }
  
  // Run validation when cart drawer opens
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'class')) {
        const target = mutation.target;
        if (target.matches && target.matches('#mini-cart, .mini-cart, .cart-drawer, [data-cart-drawer]')) {
          setTimeout(validateCart, 200);
        }
      }
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        setTimeout(validateCart, 200);
      }
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true,
    attributeFilter: ['aria-hidden', 'class']
  });
  
  // Listen for cart events
  document.addEventListener('cart:updated', () => setTimeout(validateCart, 200));
  document.addEventListener('cart:refresh', () => setTimeout(validateCart, 200));
  
  // Override fetch to detect cart changes
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    
    const url = args[0];
    if (typeof url === 'string' && 
        (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      setTimeout(validateCart, 500);
    }
    
    return response;
  };
  
  // Expose for manual triggering
  window.validateBirthstoneCart = validateCart;
  
  console.log('Birthstone cart validator initialized (lock mode)');
})();